module.exports = __webpack_public_path__ + "img/default-card-ico.af1e70dc.svg";